// extracted by mini-css-extract-plugin
export default {"valueProps":"why-shop-babylist__valueProps__lV9_d"};